import React, { Component } from "react";
import styles from "./dataAnalyse.module.scss";
import { withDataAnalyseTimeRange } from "../../../../shared/containers/containerDataAnalyseTimeRange";

import FormItem from "antd/es/form/FormItem";
import InputDate from "../../../../shared/items/contols/inputDate";
import InputTime from "../../../../shared/items/contols/inputTime";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import FormItemsInlineGroup from "../../../../shared/items/static/formItemsInlineGroup";
import FormItemsInline from "../../../../shared/items/static/formItemsInline";

class DataAnalyseTimeRange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rangeStartDate: props.rangeStartDate,
      rangeEndDate: props.rangeEndDate,
    };
  }

  skipDateOnHandle(value) {
    const { onHandleChangeStore, rangeStartDate, rangeEndDate } = this.props;

    const addDays = (date, days) => {
      date.setDate(date.getDate() + days);

      return date;
    };

    onHandleChangeStore("rangeStartDate", addDays(rangeStartDate, value));
    onHandleChangeStore("rangeEndDate", addDays(rangeEndDate, value));

    this.setState({
      rangeStartDate: rangeStartDate,
      rangeEndDate: rangeStartDate,
    });
  }

  render() {
    const { onHandleChangeStore, valueStore } = this.props;

    return (
      <div>
        <FormItemsInlineGroup>
          <FormItem title="Назад">
            <div className={styles.skipButtonContainer}>
              <SkipPreviousIcon
                fontSize="large"
                onClick={() => {
                  this.skipDateOnHandle(-1);
                }}
              />
            </div>
          </FormItem>

          <FormItemsInline>
            <FormItem title="Начальная дата">
              <InputDate
                name="rangeStartDate"
                onHandleChangeStore={onHandleChangeStore.bind(this, "rangeStartDate")}
                valueStore={valueStore}
                maxDate={new Date()}
              />
            </FormItem>

            <FormItem title="Начальное время">
              <InputTime
                name="rangeStartTime"
                onHandleChangeStore={onHandleChangeStore.bind(this, "rangeStartTime")}
                valueStore={valueStore}
              />
            </FormItem>
          </FormItemsInline>
          <FormItemsInline>
            <FormItem title="Конечная дата">
              <InputDate
                name="rangeEndDate"
                onHandleChangeStore={onHandleChangeStore.bind(this, "rangeEndDate")}
                valueStore={valueStore}
                minDate={valueStore.rangeStartDate}
              />
            </FormItem>

            <FormItem title="Конечное время">
              <InputTime name="rangeEndTime" onHandleChangeStore={onHandleChangeStore.bind(this, "rangeEndTime")} valueStore={valueStore} />
            </FormItem>
          </FormItemsInline>
          <FormItem title="Вперед">
            <div className={styles.skipButtonContainer}>
              <SkipNextIcon
                fontSize="large"
                onClick={() => {
                  this.skipDateOnHandle(1);
                }}
              />
            </div>
          </FormItem>
        </FormItemsInlineGroup>
      </div>
    );
  }
}

export default withDataAnalyseTimeRange(DataAnalyseTimeRange);
